import api from '@anm/api';
import { GetLandingRequest, SaveLandingData } from '@anm/api/modules/hosting';
import asyncEntity from '@anm/helpers/redux/asyncEntity';
import { call, take } from '@anm/helpers/saga/effects';
import { takeType } from '@anm/helpers/saga/typesafe-actions';

import { landingsActions } from '.';

const getLandingAsync = asyncEntity(landingsActions.getLandingAsync, (data: GetLandingRequest) =>
  api().hosting.getLandingPage(data)
);

const saveLandingAsync = asyncEntity(landingsActions.saveLandingAsync, (data: SaveLandingData) =>
  api().hosting.updateLandingData(data)
);

function* watchGetLanding() {
  while (true) {
    const {
      payload: { hostId }
    }: ReturnType<typeof landingsActions.getLanding> = yield take(takeType(landingsActions.getLanding));

    yield call(getLandingAsync, { hostId });
  }
}

function* watchSaveLanding() {
  while (true) {
    const { payload: data }: ReturnType<typeof landingsActions.saveLanding> = yield take(
      takeType(landingsActions.saveLanding)
    );

    yield call(saveLandingAsync, data, data);
  }
}

export default () => [call(watchGetLanding), call(watchSaveLanding)];
